import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TermsAndConditionsDetails, TermsHTML, tncAgreementVesrion } from "./content";
import TermsAndConditions from "./TermsAndConditions";
import { onboardingRoutes } from "../Routes";
import { SNETButton } from "shared/dist/components";
import { loginActions } from "../../../Services/Redux/actionCreators/userActions";
import { useNavigateTo } from "../../../GlobalRouter/hook/NavigateTo";
import FormActions from "../../../Components/PageFormComponents/FormActions";

const AcceptServiceAgreement = () => {
    const user = useSelector((state) => state.user);
    const navigateTo = useNavigateTo();

    const [agreed, setAgreed] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        if (user.isInitialized && !user.isLoggedIn) {
            navigateTo.login();
        }
    }, [user.isInitialized, user.isLoggedIn, navigateTo]);

    useEffect(() => {
        if (user.publisherTnC.accepted) {
            navigateTo.onboarding(onboardingRoutes.SINGULARITY_ACCOUNT.path);
        }
    }, [user.isInitialized, user.isLoggedIn, user.publisherTnC.accepted, navigateTo]);

    const handleAccept = () => {
        dispatch(loginActions.updateUserTnCAttribute(tncAgreementVesrion));
        navigateTo.onboarding(onboardingRoutes.SINGULARITY_ACCOUNT.path);
    };

    return (
        <Fragment>
            <TermsAndConditions
                title={TermsAndConditionsDetails.title}
                formLabel={TermsAndConditionsDetails.formLabel}
                agreed={agreed}
                onChangeAgreed={() => setAgreed(!agreed)}
                Content={TermsHTML}
            />
            <FormActions>
                <SNETButton
                    color="primary"
                    variant="contained"
                    children="accept"
                    onClick={handleAccept}
                    disabled={!agreed}
                />
            </FormActions>
        </Fragment>
    );
};

export default AcceptServiceAgreement;
